/**
 * Lodge/Accommodation Schema Component
 * From SchemaMarkup.tsx lines 221-287
 * Enhanced for AI discovery with detailed amenities
 */

import { BASE_URL, CONTACT } from '@/lib/constants';
import type { LodgeSchemaProps } from './types';

export function LodgeSchema({
  name,
  description,
  image,
  url,
  address,
  geo,
  amenities = [],
  numberOfRooms,
  priceRange = '$$$$$',
}: LodgeSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'LodgingBusiness',
    '@id': `${BASE_URL}${url}#lodge`,
    name,
    description,
    image: image.startsWith('http') ? image : `${BASE_URL}${image}`,
    url: `${BASE_URL}${url}`,
    telephone: CONTACT.whatsapp,
    priceRange,
    starRating: {
      '@type': 'Rating',
      ratingValue: '5',
    },
    address: address
      ? {
          '@type': 'PostalAddress',
          addressLocality: address.locality,
          addressRegion: address.region,
          addressCountry: address.country,
        }
      : undefined,
    geo: geo
      ? {
          '@type': 'GeoCoordinates',
          latitude: geo.latitude,
          longitude: geo.longitude,
        }
      : undefined,
    amenityFeature: amenities.map((amenity) => ({
      '@type': 'LocationFeatureSpecification',
      name: amenity,
      value: true,
    })),
    numberOfRooms: numberOfRooms,
    petsAllowed: false,
    checkinTime: '15:00',
    checkoutTime: '11:00',
    availableLanguage: ['English', 'Spanish'],
    parentOrganization: {
      '@id': `${BASE_URL}/#organization`,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
